import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderFour } from 'secondstep-components'

export const Content = styled.div`
  color: ${themeGet('colors.darkGray')};
  margin-bottom: -0.5rem;
`
export const ModalSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.875rem 1.25rem 1.25rem;
  border-radius: 10px;
  background-color: ${themeGet('colors.paleGray')};
  margin-bottom: 1.25rem;
`

export const StyledHeaderFour = styled(HeaderFour)`
  font-family: ${themeGet('font.sharpSlab.semibold')};
  margin: 0 0.5rem 0;
`

export const HeaderWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  border-style: solid;
  border-width: 0 0 2px;
  border-color: ${themeGet('colors.white')};
  justify-content: space-between;
  padding-bottom: 0.813rem;
  margin-bottom: 0.813rem;
`

export const HeaderFourAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
`
